import React, { useState } from "react";
import {
  BtnDiv,
  FirstDiv,
  ImgDiv,
  MainMintSection,
  MessageDiv,
  MintWrapper,
  SecondDiv,
  SuccessDiv,
} from "./elements";
import { Image } from "react-bootstrap";
import {
  checkicon,
  connectbtnimg,
  divider,
  fuisionimg,
  nftimg,
  stakingbtn,
} from "assets";
import { useWalletConnectClient } from "services/walletServices";
import { CommonUtility } from "utility/common";
import { elgNftAbi } from "utility/contract/elgNftAbi";
import environment from "environment";
import { ToastMessage } from "components/common";
import { energyTokenAbi } from "utility/contract/energyTokenAbi";
import Loading from "components/common/loaders/loading";
import { Link } from "react-router-dom";

const MintComp = ({ getUserNfts, setMintedToken, setNftAttributes }) => {
  const { web3Provider, account } = useWalletConnectClient();
  const [showtext, setshowtext] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  function makeFourDigitNumber(num) {
    let numStr = num.toString(); // Convert number to string
    while (numStr.length < 4) {
      numStr = "0" + numStr; // Prepend zeros until it becomes 4 digits long
    }
    return numStr;
  }
  const showmesg = () => {
    setshowtext(true);
  };
  async function fetchData(id) {
    try {
      const response = await fetch(
        `https://gateway.pinata.cloud/ipfs/QmX3kgVoeqF4wmyfTsZsHejnRaoNDaD3gwHNFppwDPC6f1/${id}`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.status}`);
      }
      const data = await response.json();
      console.log("DATATA", data);
      return data;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
  const mintNft = async () => {
    try {
      console.log("MINT NFT");
      if (!web3Provider) throw "Please connect wallet";
      setIsLoading(true);
      const contract = CommonUtility.contract(
        web3Provider,
        elgNftAbi,
        environment.ELG_NFT[environment.DEFAULT_CHAIN]
      );
      const maxCount = await contract.methods.maxUserMints().call();
      console.log("maxCount", maxCount);
      const userNfts = await contract.methods.getUserMIntedNfts(account).call();
      console.log("userNfts", userNfts);
      if (+userNfts + 1 > +maxCount) throw `Max ${maxCount} nfts allowed`;
      const totalSupply = await contract.methods.totalSupply().call();
      console.log("totalSupply", totalSupply);

      if (+totalSupply + 1 > 100) throw "Max cap reached";
      const spaceIdStatus = await contract.methods.getSpaceIdStatus().call();
      console.log("spaceIdStatus", spaceIdStatus);

      if (spaceIdStatus) {
        const spaceContract = CommonUtility.contract(
          web3Provider,
          elgNftAbi,
          environment.SPACE_ID[environment.DEFAULT_CHAIN]
        );
        const spaceBalance = await spaceContract.methods
          .balanceOf(account)
          .call();
        console.log("spaceBalance", spaceBalance);

        if (+spaceBalance == 0) throw "Unregistered Space id user";
      }
      const mintFee = await contract.methods.mintFee().call();
      console.log("mintFee", mintFee);

      const tokenAddress = await contract.methods.feeToken().call();
      console.log("tokenAddress", tokenAddress);

      const tokenContract = CommonUtility.contract(
        web3Provider,
        energyTokenAbi,
        tokenAddress
      );
      const userBalance = await tokenContract.methods.balanceOf(account).call();
      console.log("userBalance", userBalance);

      if (+userBalance < +mintFee) throw "Not enought Balance to Mint Nft";
      const allowance = await tokenContract.methods
        .allowance(account, environment.ELG_NFT[environment.DEFAULT_CHAIN])
        .call();
      console.log("ALLOWANCE", allowance);
      if (+allowance < +mintFee) {
        const approveEstimatedGasLimit = await tokenContract.methods
          .approve(environment.ELG_NFT[environment.DEFAULT_CHAIN], mintFee)
          .estimateGas({ from: account });
        console.log("userNfts", userNfts);

        const approveGasPrice = await web3Provider.eth.getGasPrice();
        console.log(
          "VALUES",
          allowance,
          approveGasPrice,
          approveEstimatedGasLimit
        );
        const approval = await tokenContract.methods
          .approve(environment.ELG_NFT[environment.DEFAULT_CHAIN], mintFee)
          .send({
            from: account,
            gasLimit: web3Provider.utils.toHex(
              +approveEstimatedGasLimit + environment.GAS_LIMIT_BUFFER
            ),
            gasPrice: web3Provider.utils.toHex(
              +approveGasPrice + environment.GAS_LIMIT_BUFFER
            ),
          });

        if (approval && approval.code == 4001)
          throw "User denied the transaction";
        if (!approval.status) throw "Transaction Failed";
      }
      const estimatedGasLimit = await contract.methods
        .mint(1)
        .estimateGas({ from: account });
      const currentGasPrice = await web3Provider.eth.getGasPrice();
      const txn = await contract.methods.mint(1).send({
        from: account,
        gasLimit: web3Provider.utils.toHex(
          +estimatedGasLimit + environment.GAS_LIMIT_BUFFER
        ),
        gasPrice: web3Provider.utils.toHex(
          +currentGasPrice + environment.GAS_PRICE_BUFFER
        ),
      });
      console.log("TRANSACTION", txn);
      if (txn && txn.code == 4001) throw "User denied the transaction";
      if (!txn.status) throw "Transaction Failed";
      const mintedToken = txn.events.Transfer.returnValues.tokenId;
      console.log("mintedToken", mintedToken);
      setMintedToken(
        `https://gateway.pinata.cloud/ipfs/QmY59S3UQCeeFBLJoUDteASfr2m73fmFxdWr6HqQA18999/${mintedToken}.png`
      );
      const ipfsData = await fetchData(mintedToken);
      const attributes = [
        {
          name: "NFT ID",
          value: `#${makeFourDigitNumber(mintedToken)}`,
        },
        {
          name: "Element",
          value: ipfsData?.attributes[0].value,
        },
        {
          name: "Trait",
          value: ipfsData?.attributes[1].value,
        },
        {
          name: "Equippable",
          value: ipfsData?.attributes[2].value,
        },
      ];
      setNftAttributes(attributes);
      await getUserNfts();
      if (txn.status) {
        setIsLoading(false);
        ToastMessage("Success!", "Transaction successful", "success");
      }
      setIsLoading(false);
      setshowtext(true);
    } catch (error) {
      setIsLoading(false);
      if (error?.message) {
        ToastMessage("Error", error?.message, "error");
      } else {
        ToastMessage("Error", error, "error");
      }
    }
  };
  return (
    <MainMintSection>
      {isLoading && <Loading content={"Transaction in progress"} />}

      {showtext ? (
        <>
          <SuccessDiv>
            <Image src={checkicon} />
            <h1>MINTING SUCCESSFUL!</h1>
          </SuccessDiv>
          <MessageDiv>
            <h5>Congratulations! Your minting was successful.</h5>
            <p>
              What's next? Explore 'My NFTs' to admire your collection or head
              <br />
              over to 'Stake' to amplify your rewards. The choice is yours in
              the
              <br /> RetroCraft universe!
            </p>
          </MessageDiv>
          <ImgDiv>
            <Link to="/mynft">
              <Image src={nftimg} />
            </Link>
            {/* <Link> */}
            <Link to="/staking">
              <Image
                src={stakingbtn}
                style={{ cursor: "not-allowed", opacity: ".5" }}
              />
            </Link>
          </ImgDiv>
          <Image src={fuisionimg} className="third-img" />
        </>
      ) : (
        <>
          <FirstDiv>
            <h1>3</h1>
            <div className="first-div">
              <h1>Start Minting!</h1>
              <p>
                Embark on the legendary journey & dive into the retro-
                <br />
                fueled adventure now
              </p>
            </div>
          </FirstDiv>
          <MintWrapper>
            <SecondDiv>
              <div className="second-div">
                <h5>Price</h5>
                <p>$RETRO 25.555</p>
              </div>
              <div className="second-div">
                <h5>Mint Fee</h5>
                <p>FREE</p>
              </div>
              <Image src={divider} fluid />
              <div className="total-div">
                <h5>TOTAL</h5>
                <p>$RETRO 25.555</p>
              </div>
            </SecondDiv>

            <BtnDiv>
              <div className="register-btn-div" onClick={() => mintNft()}>
                <Image
                  src={connectbtnimg}
                  alt="button img"
                  className="btn-img"
                />
                <h1>Confirm & Mint</h1>
              </div>
            </BtnDiv>
          </MintWrapper>
        </>
      )}
    </MainMintSection>
  );
};

export default MintComp;
